import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EuiSidebarToggleModule } from '../../eui-sidebar-toggle/sidebar-toggle.module';

import { EuiAppToolbarComponent } from './toolbar.component';
import { EuiLanguageSelectorModule } from '../../eui-language-selector';
import { EuiToolbarModule } from '../../eui-toolbar';

const COMPONENTS = [
    EuiAppToolbarComponent,
];

@NgModule({
    imports: [
        CommonModule,
        EuiSidebarToggleModule,
        EuiLanguageSelectorModule,
        EuiToolbarModule,
    ],
    declarations: [
        ...COMPONENTS,
    ],
    exports: [
        ...COMPONENTS,
    ],
})
export class EuiAppToolbarModule { }
